//services/authService.js

import { ENDPOINTS } from '../config';
import { jwtDecode } from 'jwt-decode';

export const login = async (email, password) => {
  try {
    const response = await fetch(ENDPOINTS.AUTH.LOGIN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("Invalid email or password.");
      }

      const errorText = await response.text();
      try {
        const errorJson = JSON.parse(errorText);
        throw new Error(errorJson.message || errorJson.error || "Login failed");
      } catch (e) {
        throw new Error(errorText || `Login failed (${response.status})`);
      }
    }
    const data = await response.json();
    
    if (data.token || data.Token) {
      const token = data.token || data.Token;
      localStorage.setItem('authToken', token);

      try {
        const decoded = jwtDecode(token);
        const roleClaim = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
        const userRole = decoded.role || decoded[roleClaim] || 'USER';
        
        localStorage.setItem('userRole', userRole);
        
        return { 
          success: true, 
          token: token,
          user: { ...data.User, role: userRole } 
        };
      } catch (e) {
        console.error("Token decoding failed", e);
        return { success: true, token, user: data.User };
      }
    } else {
      throw new Error("No token received from server");
    }

  } catch (error) {
    console.error("Login Service Error:", error);
    if (error.message === 'Failed to fetch') {
        throw new Error('Network error: Unable to reach server.');
    }
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userRole');
  localStorage.removeItem('openSecuritySettings');
  localStorage.removeItem('dealerLanguage');
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');
  return !!token;
};

export const requestPasswordReset = async (email) => {
  try {
    const response = await fetch(ENDPOINTS.AUTH.FORGOT_PASSWORD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    
    if (!response.ok && response.status >= 500) {
        throw new Error('Server error');
    }
    
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (email, token, newPassword) => {
  const response = await fetch(ENDPOINTS.AUTH.RESET_PASSWORD, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, token, newPassword }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to reset password');
  }

  return await response.json();
};